import type { FC, ReactElement } from 'react';

import { L10nText } from '../../../services/uiTranslations/reactBindings/L10nText';
import { useCoreDispatch } from '../../../store/CoreStore';
import { popupActions } from '../../../store/slices/popup/slice';
import { Button, ButtonVariant } from '../../controls/button/Button';
import { PopupType } from '../types';

import { BlockingModalContent } from './BlockingModalContent';

export const BeforeInactivityConnected: FC = (): ReactElement => {
  const dispatch = useCoreDispatch();

  const action = [
    <Button
      key="OK"
      tk="OK"
      variant={ButtonVariant.ACCENT}
      onClick={() => {
        dispatch(popupActions.dismissPopup(PopupType.BeforeInactivity));
      }}
    />,
  ];

  return (
    <BlockingModalContent actions={action} title={<L10nText tk="POPUP_INACTIVITY_NOTICE_TITLE" />}>
      <L10nText tk="POPUP_INACTIVITY_NOTICE" />
    </BlockingModalContent>
  );
};
